"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@firebase/util");
var Path_1 = require("../util/Path");
var Operation_1 = require("./Operation");
var AckUserWrite = /** @class */ (function () {
 /**
 *
 * @param {!Path} path
 * @param {!ImmutableTree} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
 * @param {!boolean} revert
 */
 function AckUserWrite(
 /**@inheritDoc */ path, 
 /**@inheritDoc */ affectedTree, 
 /**@inheritDoc */ revert) {
 this.path = path;
 this.affectedTree = affectedTree;
 this.revert = revert;
 /** @inheritDoc */
 this.type = Operation_1.OperationType.ACK_USER_WRITE;
 /** @inheritDoc */
 this.source = Operation_1.OperationSource.User;
 }
 /**
 * @inheritDoc
 */
 AckUserWrite.prototype.operationForChild = function (childName) {
 if (!this.path.isEmpty()) {
 util_1.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
 return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
 }
 else if (this.affectedTree.value != null) {
 util_1.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
 // All child locations are affected as well; just return same operation.
 return this;
 }
 else {
 var childTree = this.affectedTree.subtree(new Path_1.Path(childName));
 return new AckUserWrite(Path_1.Path.Empty, childTree, this.revert);
 }
 };
 return AckUserWrite;
}());
exports.AckUserWrite = AckUserWrite;

//# sourceMappingURL=AckUserWrite.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/operation/AckUserWrite.js
// module id = 87
// module chunks = 0